import React from 'react';
import './BifurcatedPromo.css';

interface BifurcatedPromoProps {
  id: string;
  title: string;
  heading: string;
  description: string;
  images?: string[]; // make optional in case data is missing
}

const BifurcatedPromo: React.FC<BifurcatedPromoProps> = ({
  id,
  title,
  heading,
  description,
  images = [], // fallback to empty array

}) => {
  return (
<section className={`bifurcated-promo ${id}`} id={id}>


      <div className="promo-text">
        <h3>{title}</h3>
        <h1>{heading}</h1>
        <p>{description}</p>
      </div>
     <div className={`promo-images ${images.length === 1 ? 'single-image' : ''}`}>
  {images.map((img, idx) => (
    <img key={idx} src={`${img}`} alt={`promo-${idx}`} />
  ))}
</div>

    </section>
  );
};

export default BifurcatedPromo;
